import { render, staticRenderFns } from "./AdminDetailProfile.vue?vue&type=template&id=d635748a&scoped=true&"
import script from "./AdminDetailProfile.vue?vue&type=script&lang=js&"
export * from "./AdminDetailProfile.vue?vue&type=script&lang=js&"
import style0 from "./AdminDetailProfile.vue?vue&type=style&index=0&id=d635748a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d635748a",
  null
  
)

export default component.exports